<template>
  <v-card class="mx-auto flex-grow-1">
    <v-toolbar short color="red accent-2" dense dark elevation="0" class="m-0 p-0">
      <v-toolbar-title class="m-0 pt-4">
        <p class="subtitle-2 text-center white--text font-weight-normal">
          <v-icon class="mx-2">mdi-email</v-icon>
          Contatos - Web Site
        </p>
      </v-toolbar-title>
    </v-toolbar>

    <v-list two-line>
      <v-list-item-group active-class="green--text">
        <template v-for="(item, index) in visibleMessages">
          <v-list-item :key="item.index">
            <template v-slot:default="{ active }">
              <v-list-item-content>
                <v-list-item-title v-text="item.subject"></v-list-item-title>
                <v-list-item-subtitle
                  class="text--primary"
                  v-text="item.name"
                ></v-list-item-subtitle>
                <v-list-item-subtitle v-text="item.message"></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-list-item-action-text v-text="item.created_at"></v-list-item-action-text>
                <v-icon v-if="!active" color="grey lighten-1"> mdi-check </v-icon>
                <v-icon v-else color="green"> mdi-check </v-icon>
              </v-list-item-action>
            </template>
          </v-list-item>

          <v-divider v-if="index + 1 < visibleMessages.length" :key="index"></v-divider>
        </template>
      </v-list-item-group>
    </v-list>

    <v-divider></v-divider>
    
    <v-card-actions dense class="d-flex" cols="12" col="12">
      <v-pagination
        v-if="contactMessagesWebSite.length >= perPage"
        v-model="page"
        color="red accent-2"
        circle
        :length="Math.ceil(contactMessagesWebSite.length / perPage)"
      ></v-pagination>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data: function () {
    return {
      page: 1,
      perPage: 4,
    }
  },
  computed: {
    ...mapState('employees', ['contactMessagesWebSite']),
    visibleMessages() {
      return this.contactMessagesWebSite.slice(
        (this.page - 1) * this.perPage,
        this.page * this.perPage
      )
    },
  },
}
</script>

